"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colors = require("HubStyleTokens/colors");

var _UICheckmark = _interopRequireDefault(require("../icon/icons/UICheckmark"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _Styles = require("../utils/Styles");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _decorators = require("../utils/propTypes/decorators");

var _useFocused2 = _interopRequireDefault(require("../hooks/useFocused"));

var _useChecked2 = require("../hooks/useChecked");

var SIZE_VALUES = {
  default: 40,
  sm: 32,
  xs: 26
};

var Outer = _styledComponents.default.label.withConfig({
  displayName: "UIToggle__Outer",
  componentId: "sc-1xoijgg-0"
})(["position:relative;display:inline-block;vertical-align:middle;user-select:none;color:", ";cursor:", ";"], function (_ref) {
  var isOnDark = _ref.isOnDark;
  return isOnDark && _colors.BATTLESHIP;
}, function (_ref2) {
  var disabledOrReadOnly = _ref2.disabledOrReadOnly;
  return disabledOrReadOnly ? 'not-allowed' : 'pointer';
});

var Switch = _styledComponents.default.span.withConfig({
  displayName: "UIToggle__Switch",
  componentId: "sc-1xoijgg-1"
})(["position:relative;display:inline-block;vertical-align:middle;height:", "px;width:", ";min-width:", "px;background-color:", ";box-shadow:", ";", ";.hubspot-enable-focus-styles &{", ";}"], function (_ref3) {
  var size = _ref3.size;
  return SIZE_VALUES[size];
}, function (_ref4) {
  var size = _ref4.size;
  return size !== 'default' && SIZE_VALUES[size] * 2 + "px";
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'default' ? 80 : 0;
}, function (_ref6) {
  var checked = _ref6.checked,
      disabledOrReadOnly = _ref6.disabledOrReadOnly,
      isOnDark = _ref6.isOnDark,
      size = _ref6.size;
  if (disabledOrReadOnly) return _colors.GYPSUM;
  if (checked) return _colors.CALYPSO;
  if (isOnDark) return _colors.HEFFALUMP;
  return size === 'default' ? _colors.KOALA : _colors.GYPSUM;
}, function (_ref7) {
  var checked = _ref7.checked,
      isOnDark = _ref7.isOnDark;
  return !checked && "inset 0 0 0 1px " + (isOnDark ? _colors.SLINKY : _colors.BATTLESHIP);
}, (0, _Styles.setBorderRadius)(), function (_ref8) {
  var focused = _ref8.focused;
  return focused && _Styles.uiFocus;
});

var Handle = _styledComponents.default.span.withConfig({
  displayName: "UIToggle__Handle",
  componentId: "sc-1xoijgg-2"
})(["position:absolute;top:0;left:", ";transform:", ";height:", "px;width:", "px;padding:", "px;overflow:hidden;background-color:", ";box-shadow:", ";", ";", ";"], function (_ref9) {
  var checked = _ref9.checked;
  return checked ? '100%' : 0;
}, function (_ref10) {
  var checked = _ref10.checked;
  return checked && 'translateX(-100%)';
}, function (_ref11) {
  var size = _ref11.size;
  return SIZE_VALUES[size];
}, function (_ref12) {
  var size = _ref12.size;
  return SIZE_VALUES[size];
}, function (_ref13) {
  var size = _ref13.size;
  return size === 'xs' ? 5 : 7;
}, function (_ref14) {
  var disabledOrReadOnly = _ref14.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.GYPSUM : _colors.OLAF;
}, function (_ref15) {
  var checked = _ref15.checked,
      disabledOrReadOnly = _ref15.disabledOrReadOnly,
      isOnDark = _ref15.isOnDark;
  var boxShadowColor;

  if (disabledOrReadOnly) {
    boxShadowColor = _colors.BATTLESHIP;
  } else if (checked) {
    boxShadowColor = _colors.CALYPSO;
  } else {
    boxShadowColor = isOnDark ? _colors.SLINKY : _colors.BATTLESHIP;
  }

  return "0 0 0 1px " + boxShadowColor + ", 0 5px 5px 0 rgba(0, 0, 0, 0.08)";
}, (0, _Styles.setBorderRadius)(), (0, _Styles.setUiTransition)());

var Text = _styledComponents.default.span.withConfig({
  displayName: "UIToggle__Text",
  componentId: "sc-1xoijgg-3"
})(["position:relative;display:block;top:", ";", ";text-align:center;line-height:41px;padding-left:", "px;padding-right:", "px;visibility:", ";color:", ";", ";"], function (_ref16) {
  var checked = _ref16.checked,
      size = _ref16.size;
  return size === 'default' && !checked && '-40px';
}, _Styles.FONT_FAMILIES.demibold, function (_ref17) {
  var checked = _ref17.checked;
  return checked ? 16 : 56;
}, function (_ref18) {
  var checked = _ref18.checked;
  return checked ? 56 : 16;
}, function (_ref19) {
  var visible = _ref19.visible;
  return !visible && 'hidden';
}, function (_ref20) {
  var checked = _ref20.checked,
      disabledOrReadOnly = _ref20.disabledOrReadOnly;
  if (disabledOrReadOnly) return _colors.BUTTON_DISABLED_TEXT;
  if (checked) return _colors.OLAF;
  return null;
}, (0, _Styles.setFontSmoothing)());

var Checkmark = (0, _styledComponents.default)(function (_ref21) {
  var className = _ref21.className;
  return _react.default.createElement(_UICheckmark.default, {
    className: className
  });
}).withConfig({
  displayName: "UIToggle__Checkmark",
  componentId: "sc-1xoijgg-4"
})(["fill:", ";stroke:", ";stroke-width:2;"], function (_ref22) {
  var disabledOrReadOnly = _ref22.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.BUTTON_DISABLED_TEXT : _colors.CALYPSO;
}, function (_ref23) {
  var disabledOrReadOnly = _ref23.disabledOrReadOnly;
  return disabledOrReadOnly ? _colors.GYPSUM : _colors.OLAF;
});
var UIToggle = (0, _memoWithDisplayName.default)('UIToggle', function (props) {
  var className = props.className,
      disabled = props.disabled,
      __focused = props.focused,
      __onFocus = props.onFocus,
      __onBlur = props.onBlur,
      id = props.id,
      name = props.name,
      __checked = props.checked,
      __onChange = props.onChange,
      __defaultChecked = props.defaultChecked,
      onClick = props.onClick,
      readOnly = props.readOnly,
      size = props.size,
      textChecked = props.textChecked,
      textUnchecked = props.textUnchecked,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "disabled", "focused", "onFocus", "onBlur", "id", "name", "checked", "onChange", "defaultChecked", "onClick", "readOnly", "size", "textChecked", "textUnchecked", "use"]);

  var _useChecked = (0, _useChecked2.useChecked)(props),
      checked = _useChecked.checked,
      onChange = _useChecked.onChange;

  var disabledOrReadOnly = disabled || readOnly;
  var labelClassName = (0, _classnames.default)('uiToggle', 'private-form__toggle-switch', className, {
    'private-form__toggle-switch--disabled': disabledOrReadOnly
  });
  var switchClassName = (0, _classnames.default)('uiToggleSwitch', 'private-form__toggle-switch__inner', {
    uiToggleSwitchOn: checked
  });

  var _useFocused = (0, _useFocused2.default)(props),
      focused = _useFocused.focused,
      onFocus = _useFocused.onFocus,
      onBlur = _useFocused.onBlur;

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  var isOnDark = use === 'on-dark';

  var handleChange = function handleChange(evt) {
    if (disabledOrReadOnly) {
      evt.preventDefault();
      return;
    }

    onChange(evt);
  };

  return _react.default.createElement(Outer, Object.assign({}, rest, {
    className: labelClassName,
    disabledOrReadOnly: disabledOrReadOnly,
    isOnDark: isOnDark,
    size: shorthandSize,
    onFocus: onFocus,
    onBlur: onBlur
  }), _react.default.createElement("input", {
    checked: checked,
    disabled: disabled,
    className: "private-form__toggle-input sr-only",
    id: id,
    name: name,
    onChange: handleChange,
    onClick: onClick,
    readOnly: readOnly,
    type: "checkbox"
  }), _react.default.createElement(Switch, {
    checked: checked,
    className: switchClassName,
    disabledOrReadOnly: disabledOrReadOnly,
    focused: focused,
    role: "presentation",
    size: shorthandSize,
    isOnDark: isOnDark
  }, _react.default.createElement(Text, {
    checked: true,
    disabledOrReadOnly: disabledOrReadOnly,
    size: shorthandSize,
    visible: checked,
    className: shorthandSize !== 'default' && 'sr-only'
  }, (0, _lazyEval.default)(textChecked)), _react.default.createElement(Text, {
    checked: false,
    disabledOrReadOnly: disabledOrReadOnly,
    size: shorthandSize,
    visible: !checked,
    className: (0, _classnames.default)('private-form__toggle-switch__label--unchecked', shorthandSize !== 'default' && 'sr-only')
  }, (0, _lazyEval.default)(textUnchecked)), _react.default.createElement(Handle, {
    checked: checked,
    disabledOrReadOnly: disabledOrReadOnly,
    isOnDark: isOnDark,
    size: shorthandSize
  }, checked && _react.default.createElement(Checkmark, {
    disabledOrReadOnly: disabledOrReadOnly
  }))));
});
UIToggle.propTypes = Object.assign({}, _useChecked2.checkedPropTypes, {
  disabled: _propTypes.default.bool,
  focused: (0, _decorators.hidden)(_propTypes.default.bool),
  name: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  size: _propTypes.default.oneOfType([(0, _tshirtSize.propTypeForSizes)(['xs', 'sm']), _propTypes.default.oneOf(['default'])]).isRequired,
  textChecked: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  textUnchecked: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  use: _propTypes.default.oneOf(['default', 'on-dark'])
});
UIToggle.defaultProps = Object.assign({}, _useChecked2.checkedDefaultProps, {
  size: 'default',
  textChecked: function textChecked() {
    return _I18n.default.text('salesUI.UIToggle.checkedLabel');
  },
  textUnchecked: function textUnchecked() {
    return _I18n.default.text('salesUI.UIToggle.uncheckedLabel');
  },
  use: 'default'
});
var _default = UIToggle;
exports.default = _default;
module.exports = exports.default;